import React from 'react';
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { Button, TextField, Box, Typography } from "@mui/material";
import clsx from "clsx";
import { Col, Row, Space } from "antd";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateIcon from "../../../../Shared/components/Icons/Date";
import { idNamingConversion } from '../../../../../helpers/utilities';


export const BatchForm = (props) => {
    const { visible, handleSubmit, productForm, form, error,
        handleClose, handleAddMore, title, changeHandler
    } = props;

    const classes = customStyles();
    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            width={'495px'}
            title={`${title} Batch Details`}
            className={clsx(classes.closeBackGround, classes.width100P)}
            component={
                <Box
                    className={clsx(classes.customForm, classes.removeUnderline)}
                    component="form"
                    autoComplete='off'
                    onSubmit={(e) => handleSubmit(e)}>
                    <div className={classes.customFormFlex}>
                        <Row gutter={30}>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Batch ID</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.batchId || '---'}</Typography>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Batch Number</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.batchNumber || '---'}</Typography>
                            </Col>
                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Product</Typography>
                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{productForm?.productName || '---'}</Typography>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <TextField autoComplete='one-time-code'
                                    label={["Quantity ", <span key={'Quantity'} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    type={'number'}
                                    className={clsx(classes.margin20t)}
                                    error={error.quantity ? true : false}
                                    helperText={error.quantity}
                                    name={"quantity"}
                                    onWheel={(e) => e.target.blur()}
                                    fullWidth
                                    value={form?.quantity || ''}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    id={idNamingConversion('Quantity', 'productBatch', 'TextField')}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={form?.expiryDate || null}
                                            label="Expiry Date"
                                            name={"expiryDate"}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            slotProps={{
                                                textField: {
                                                    id: idNamingConversion('Expiry Date', 'productBatch', 'TextField'),
                                                    autoComplete: 'one-time-code'
                                                },
                                            }}
                                            format="dd/MM/yyyy"
                                            onChange={(newValue) => { changeHandler(newValue, 'expiryDate') }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={form?.bestDate || null}
                                            label="Best Before | Best By Date"
                                            name={"bestDate"}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            slotProps={{
                                                textField: {
                                                    id: idNamingConversion('Best Before', 'productBatch', 'TextField'),
                                                    autoComplete: 'one-time-code'
                                                },
                                            }}
                                            format="dd/MM/yyyy"
                                            onChange={(newValue) => { changeHandler(newValue, 'bestDate') }}
                                            renderInput={(params) => <TextField autoComplete='one-time-code' {...params} />}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Col>
                            <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                <div className={clsx(classes.margin20t, classes.dateAdjust)}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            fullWidth
                                            slots={{
                                                openPickerIcon: DateIcon
                                            }}
                                            views={['year', 'month', 'day']}
                                            value={form?.mfgDate || null}
                                            label={["Batch Mfg. Date ", <span key={'Batch Mfg. Date'} className={classes.colorRedRequired}> *</span>]}
                                            name={"mfgDate"}
                                            InputProps={{
                                                classes: {
                                                    input: classes.textFieldColor,
                                                }
                                            }}
                                            slotProps={{
                                                textField: {
                                                    error: error?.mfgDate ? true : false,
                                                    helperText: error?.mfgDate,
                                                    id: idNamingConversion('Best Before', 'productBatch', 'TextField'),
                                                    autoComplete: 'one-time-code'
                                                },
                                            }}
                                            format="dd/MM/yyyy"
                                            onChange={(newValue) => { changeHandler(newValue, 'mfgDate') }}
                                            renderInput={(params) => <TextField autoComplete='one-time-code' {...params}
                                                error={error.mfgDate ? true : false}
                                                helperText={error.mfgDate} />}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className={clsx(classes.btnParent)}>
                        <Space direction="horizontal" align="center" size={[10, 10]}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn)}>
                                Save
                            </Button>
                            <Button
                                key="add"
                                color='primary'
                                variant="contained"
                                className={clsx(classes.AddMoreBtn)}
                                onClick={(e) => handleAddMore(e, 'batch')}
                            >
                                Add More
                            </Button>
                        </Space>
                    </div>
                </Box>
            }
        />
    )
}
